<script setup lang="ts">
  const props = defineProps({
      isPublicPage: {
          type: Boolean,
          required: false,
          default: false
      }
  });
  const isPublicPage = ref(props.isPublicPage);
</script>

<template>
  <div class="container">
    <div class="p5 mt-10">
      <img src="/wdi-logo-rgb.png" alt="WDI Logo" class="w-1/2 m-auto mb-10">
      <p v-if="isPublicPage">
        We are currently undergoing scheduled maintenance - please return shortly to complete your application. Your existing progress has been saved.
      </p>
      <p v-else>
        The WDI Portal is undergoing maintenance. Contact support for more information.
      </p>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}
p {
  font-size: 1.2rem;
  margin: 1rem 0;
}
</style>